<template>
  <div style="display: flex">
    <!-- 全部-全部 -->
    <div class="deal-statistics" v-if="tabsOneActionIndex==0&&tabsTwoActiveIndex==0">
      <div class="deal-data" v-for="(item ,index) in data" :key="index">
        <div class="closed">
          <div class="closed-tag" v-if="item.type==1">
            <span>已成交</span>
          </div>

          <div class="unsettled-tag" v-if="item.type==0">
            <span>未成交</span>
          </div>

          <template v-if="item.type==2">
            <div class="objection-tag">
              <span>异议客户</span>
            </div>
            <div class="insured-customer-text">
              <span>{{ item.dissentCustomerNum || 0 }}</span>
            </div>
          </template>

          <div class="insured-customer-text" v-if="item.type!=2">
            <span>自有客户</span>
            <span>{{ item.owerCustomerNum || 0 }}</span>
          </div>
          <div class="line" v-if="item.type!=2"></div>
        </div>

        <div class="closed">
          <div class="insured-customer-text" v-if="item.type!=2">
            <span>预约客户</span>
            <span>{{ item.soruceCustomerNum || 0 }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 全部-预约客户 全部-自有客户-->
    <div class="deal-statistics" v-if="tabsOneActionIndex==0&&(tabsTwoActiveIndex==1 || tabsTwoActiveIndex==2)">
      <div class="deal-data" v-for="(item ,index) in data" :key="index">
        <div class="closed">
          <div class="closed-tag" v-if="item.type==1">
            <span>已成交</span>
          </div>

          <div class="unsettled-tag" v-if="item.type==0">
            <span>未成交</span>
          </div>

          <div class="insured-customer-text">
            <span>客户</span>
            <span>{{ item.customerNum || 0 }}</span>
          </div>
          <div class="line"></div>
        </div>

        <div class="closed">
          <div class="insured-customer-text">
            <span>保费</span>
            <span>{{ item.feeTotal || 0 }}元</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 未成交-全部 未成交-预约客户 未成交-自有客户-->
    <div class="deal-statistics" v-if="tabsOneActionIndex==1">
      <div class="deal-data" v-for="(item, index) in data" :key="index">
        <div class="closed">
          <div class="cumulative-tag" v-if="item.type==-1">
            <span>历史累计</span>
          </div>

          <div class="newly-add-tag" v-if="item.type==-2">
            <span>今日新增</span>
          </div>

          <div class="insured-customer-text">
            <span>未成交客户</span>
            <span>{{ item.customerNum || 0 }}</span>
          </div>
          <div class="line"></div>
        </div>

        <div class="closed">
          <div class="insured-customer-text">
            <span>未成交保费</span>
            <span>{{ item.feeTotal || 0 }}元</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 已成交-全部 已成交-预约客户 已成交-自有客户 -->
    <div class="deal-statistics" v-if="tabsOneActionIndex==2">
      <div class="deal-data" v-for="(item, index) in data" :key="index">
        <div class="closed">
          <div class="cumulative-tag" v-if="item.type==-1">
            <span>历史累计</span>
          </div>

          <div class="newly-add-tag" v-if="item.type==-2">
            <span>今日新增</span>
          </div>

          <div class="insured-customer-text">
            <span>已成交客户</span>
            <span>{{ item.customerNum || 0 }}</span>
          </div>
          <div class="line"></div>
        </div>

        <div class="closed">
          <div class="insured-customer-text">
            <span>已成交保费</span>
            <span>{{ item.feeTotal || 0 }}元</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data","tabsOneActionIndex","tabsTwoActiveIndex"],
};
</script>

<style lang="scss" scoped>
.deal-statistics {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .deal-data {
    margin-top: 18px;
    display: flex;
    margin-right: 105px;
    .closed {
      display: flex;
      align-items: center;
      .closed-tag {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #d0edca;
        border-radius: 2px;
        height: 22px;
        background-color: #f1fcef;
        color: #35bf3f;
        padding: 0 5px;
        font-size: 12px;
        white-space: nowrap;
      }
      .unsettled-tag {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #f8dddd;
        border-radius: 2px;
        height: 22px;
        background-color: #fff4f4;
        color: #ea5858;
        padding: 0 5px;
        font-size: 12px;
        white-space: nowrap;
      }
      .objection-tag {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ffe9d9;
        border-radius: 2px;
        height: 22px;
        background-color: #fffaf7;
        color: #f59045;
        padding: 0 5px;
        font-size: 12px;
        white-space: nowrap;
      }
      .newly-add-tag {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #D0EDCA;
        border-radius: 2px;
        height: 22px;
        background-color: #F1FCEF;
        color: #35BF3F;
        padding: 0 5px;
        font-size: 12px;
        white-space: nowrap;
      }
      .cumulative-tag {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #FFE9D9;
        border-radius: 2px;
        height: 22px;
        background-color: #FFFAF7;
        color: #F59045;
        padding: 0 5px;
        font-size: 12px;
        white-space: nowrap;
      }
      .insured-customer-text {
        display: flex;
        align-items: center;
        margin-left: 10px;
        white-space: nowrap;
        span:first-child {
          color: #515C6F;
          font-size: 14px;
        }
        span:last-child {
          margin-left: 10px;
          color: #3C464F;
          font-size: 18px;          
        }
      }
      .line {
        width: 1px;
        background-color: #eeeeee;
        height: 14px;
        margin: 0 10px 0 20px;
      }
    }
  }
}
</style>